export type Vertical = 'flight' | 'hotel' | 'prepackage' | 'fhh' | 'carrental';

export const verticals: Record<string, Vertical> = {
    flight: 'flight',
    hotel: 'hotel',
    prepackage: 'prepackage',
    fhh: 'fhh',
    carrental: 'carrental',
};
